import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import {useCustomerAuth  } from "./CustomerAuthContext"; // update this path if different

export default function CustomerProtectedRoute({ children }) {
  const { isAuthenticated } = useCustomerAuth ();
  const location = useLocation();

  if (!isAuthenticated) {
    const nextPath = location.pathname + location.search;
    return (
      <Navigate
        to={`/customer-login?next=${encodeURIComponent(nextPath)}`}
        replace
      />
    );
  }

  return children;
}
